import React from 'react';
import { getShowtimeContext } from './ShowtimeContext';
export const ShowtimeProvider = (props) => {
    const { actions, appContext, children, config, providableUrls, userContext, } = props;
    const ReactShowtimeContext = getShowtimeContext();
    return (React.createElement(ReactShowtimeContext.Consumer, null, (context = {}) => {
        let updatedContext = context;
        if (actions && updatedContext.actions !== actions) {
            updatedContext = Object.assign(Object.assign({}, updatedContext), { actions });
        }
        if (appContext && updatedContext.appContext !== appContext) {
            updatedContext = Object.assign(Object.assign({}, updatedContext), { appContext });
        }
        if (config && updatedContext.config !== config) {
            updatedContext = Object.assign(Object.assign({}, updatedContext), { config });
        }
        if (providableUrls && updatedContext.providableUrls !== providableUrls) {
            updatedContext = Object.assign(Object.assign({}, updatedContext), { providableUrls });
        }
        if (userContext && updatedContext.userContext !== userContext) {
            updatedContext = Object.assign(Object.assign({}, updatedContext), { userContext });
        }
        return (React.createElement(ReactShowtimeContext.Provider, { value: updatedContext }, children));
    }));
};
//# sourceMappingURL=ShowtimeProvider.js.map